import React from 'react';
import styles from './styles/Box.module.scss';

type BoxProps = {
  className?: string;
  wrapper?: boolean;
  color?: string;
  size?: string;
  noStyles?: boolean;
  children: React.ReactNode;
};

const Box: React.FunctionComponent<BoxProps> = (props: BoxProps) => {
  const { className, wrapper, color, size, noStyles, children } = props;

  return (
    <div
      className={`lumme-box ${className} ${wrapper ? styles.wrapper : styles.box} ${size ? styles[size] : ''} ${
        color ? `bg-${color} ${styles[color]}` : ''
      } ${noStyles ? styles.noStyles : ''}`}
    >
      {children}
    </div>
  );
};

export default Box;
